/*
 * Select multiple items
 *
 * Example:
 *
 * JS:
 * const carousels = datajsAll('carousel-block');
 *
 * carousels.forEach((carousel) => {
 *    this.carouselConfig(carousel);
 * });
 *
 * HTML:
 * <div class="o-carousel__slides" data-js="carousel-block">
 */
export function datajsAll(selector, parent) {
	return Array.prototype.slice.call((parent || document).querySelectorAll('[data-js~="' + selector + '"]'));
}

/*
 * Select first (single) item
 *
 * Example:
 *
 * JS:
 * const headerHeight = datajs('site-header').offsetHeight;
 *
 * HTML:
 * <header class="o-siteHeader" data-js="site-header">
 */
export function datajs(selector, parent) {
	return (parent || document).querySelector('[data-js~="' + selector + '"]');
}

// Collapse desktop navigation (top level) open submenu items
export function collapseOpenSiteNavItems() {
	const siteHeader = datajs('site-header');
	const siteNav = document.querySelector('.js-siteNav');

	if (!siteNav) {
		return;
	}

	// Good idea to match with submenu CSS transition-duration
	const animationDelayMs = 200;

	const topLevelItems = siteNav.querySelectorAll(':scope > .menu-item');

	siteHeader.classList.remove('has-openSubmenus');

	topLevelItems.forEach((item) => {
		if (item.getAttribute('aria-expanded') === 'true') {
			item.setAttribute('aria-expanded', 'false');

			setTimeout(function () {
				item.classList.remove('is-activated');
			}, animationDelayMs);
		}
	});
}

// Get page data from WordPress REST API
export function getPageData(args, cb) {
	const { pageId, postType } = args;
	let apiUrl = window.AppGlobals.apiUrl || null;
	let postTypeEndpoint = 'posts';

	if (postType === 'page') {
		postTypeEndpoint = 'pages';
	} else {
		postTypeEndpoint = postType;
	}

	if (!apiUrl) {
		return false;
	}

	var url = apiUrl + 'wp/v2/' + postTypeEndpoint + '/' + pageId;

	fetch(url)
		.then((response) => response.json())
		.then((data) => cb(data));
}

// Trap focus helper
export function trapFocus(element) {
	const focusableEls = element.querySelectorAll(
		'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
	);
	const firstFocusableEl = focusableEls[0];
	const lastFocusableEl = focusableEls[focusableEls.length - 1];
	const KEYCODE_TAB = 9;

	element.addEventListener('keydown', function (e) {
		const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			/* shift + tab */ if (document.activeElement === firstFocusableEl) {
				lastFocusableEl.focus();
				e.preventDefault();
			}
		} /* tab */ else {
			if (document.activeElement === lastFocusableEl) {
				firstFocusableEl.focus();
				e.preventDefault();
			}
		}
	});
}
